import { useEffect, useRef } from 'react';

type Options = {
  skip?: boolean;
};

export const useCounterReserveBalancer = (
  reservePrice: number = 0,
  counter: number = 0,
  updateReserve: (newValue: number) => void,
  updateCounter: (newValue: number) => void,
  { skip = false }: Options = {}
) => {
  const previousReserve = useRef(Number(reservePrice) || 0);
  const previousCounter = useRef(Number(counter) || 0);
  useEffect(() => {
    if (skip) return;

    const update = () => {
      const parsedCounter = Number(counter) || 0;
      const parsedReserve = Number(reservePrice) || 0;

      if (previousCounter.current !== parsedCounter && !!parsedCounter && parsedCounter < parsedReserve) {
        updateReserve(parsedCounter);
      }

      if (previousReserve.current !== parsedReserve && !!parsedReserve && parsedCounter < parsedReserve) {
        updateCounter(parsedReserve);
      }

      previousCounter.current = parsedCounter;
      previousReserve.current = parsedReserve;
    };

    const debouncedUpdate = setTimeout(() => {
      update();
    }, 1000);

    return () => clearTimeout(debouncedUpdate);
  }, [reservePrice, counter, skip]);
};
